<template>
  <div>
    <admin-change-approval-rule ref="changeApprovalRule" :ruleId="mainRuleId" :disabled="disableEditing" :creating="creating"></admin-change-approval-rule>
    <br />
    <el-alert v-if="alertTitle !== ''"
      :title="alertTitle"
      :type="alertType"
      :description="callInfo"
      :closable="false"
      show-icon>
    </el-alert>
    <button class="btn btn-primary" @click="create()" :disabled="disableEditing">Create Approval Rule</button>
    <br />
    <div v-if="isLoading">
      Rule Creation Processing...
    </div>
  </div>
</template>

<script>

import router from '@/router'
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'createApprovalRule',
  data () {
    return {
      isLoading: false,
      callInfo: '',
      alertType: '',
      alertTitle: '',
      mainRuleId: 0,
      approvalRuleValidState: false,
      disableEditing: true,
      creating: true
    }
  },
  created: function () {
    this.$on('createRuleValidation', function (value) {
      this.approvalRuleValidState = value
      this.isLoading = false
    })
    this.startUp()
  },
  methods: {
    startUp () {
      if (this.$store.getters.isAdmin) {
        // creating new rule so can edit
        this.disableEditing = false
      } else {
        this.disableEditing = true
      }
    },
    create () {
      this.isLoading = true
      this.alertTitle = ''
      // check forms
      var formValid = false
      this.checkFormValidation()
      if (this.approvalRuleValidState === true) {
        formValid = true
      }
      if (formValid) {
        const loading = this.$loading({
          lock: true,
          text: 'Processing',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.$refs.changeApprovalRule.formSubmit().then(response => {
          // debugger
          this.mainRuleId = response.data.id
          this.isLoading = false
          loading.close()
          this.disableEditing = true
          helperMethods.showNotification(this, 'Approval Rule Successfully Created!', 'Approval Rule Created', 'success', 10000)
          router.push('changeApprovalRule/' + this.mainRuleId)
        }).catch(reject => {
          this.isLoading = false
          this.disableEditing = false
          loading.close()
          helperMethods.showNotification(this, 'Error creating Approval Rule', reject.body, 'error', 30000)
        })
      }
    },
    checkFormValidation () {
      this.$refs.changeApprovalRule.checkIfValid()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
